import Main from '@/components/main/Main';
// 支付模块的路由
const commonRoutes = [
  {
    name: 'common',
    path: '/common',
    component: Main,
    redirect: '/common/category',
    meta: {
      showInMenu: true,
      showAlways: true, // 表示一定要展示子菜单
      title: '公共',
      icon: 'ios-apps'
    },
    children: [
      {
        name: 'common_category',
        path: 'category',
        component: () => import('@/emc-common/views/category'),
        meta: {
          showInMenu: true,
          path: '/common/category',
          title: '类目管理',
          icon: 'logo-apple'
        }
      },
      {
        name: 'common_category_edit_page',
        path: '/common/category/EditPage',
        component: () => import('@/emc-common/views/category/EditCategory'),
        meta: {
          showInMenu: false
        }
      }
    ]
  }
];

export default commonRoutes;
